import React, {useEffect, useState } from 'react';
import {
    Box,
    Button,
    Flex,
    Text,
    Tabs,
    TabList,
    Tab,
    TabPanels,
    TabPanel,
} from '@chakra-ui/react';
import {useDispatch, useSelector } from 'react-redux';
import {fetchUpcomingEvents, setEventDetails, setUpcomingEventsPagination, setUpcomingEventsPageSize } from '../redux/slices/eventSlice';
import { format } from 'date-fns';
import DotLoader from '../components/loaders/DotLoader';
import { setFormModal } from '../redux/slices/modalSlice';
import CustomTablePage2 from '../components/CustomTablePage2';


const EventMgtMemberModule = () => {
    const dispatch = useDispatch();
    const [eventType, setEventType] = useState('upcoming')
    const eventsData  = useSelector((state) => state?.event);
    const upcomingEventsData = eventsData?.upcomingEvents;

    useEffect(() => {
        dispatch(fetchUpcomingEvents(eventType))
    }, [dispatch, eventType, eventsData?.upcomingEventsParams]);
    
    const handleViewEventDetails = (item) => {
        dispatch(setEventDetails(item));
        dispatch(setFormModal({ status: true, title: "Event Details", type: "viewEventDetailsStudent", size: "2xl" }));
    };

    const handlePagination = (page) => {
        dispatch(setUpcomingEventsPagination(page));
    };

    const handlePageSize = (size) => {
        dispatch(setUpcomingEventsPageSize(size));
    };

    const tableProps = {
        data: upcomingEventsData?.data,
        title: {
            eventName: "Event Name",
            eventCategory: "Event Category",
            startDate: "Start Date",
            endDate: "End Date",
            eventLocation: "Venue",
            creditPoint: "Credit Points",
            viewDetails: "",
        },
        dataKeys: [
            "eventName",
            "eventCategory",
            "startDate",
            "endDate",
            "eventLocation",
            "creditPoint",
            "viewDetails",
        ],
        showColorStrip: false,
        handlePagination,
        handlePageSize,
        itemsPerPage: upcomingEventsData?.currentPageRecord,
        totalRecord: upcomingEventsData?.totalRecord,
        pageNumber: eventsData?.upcomingEventsParams?.page,
        nextPage: upcomingEventsData?.nextPage,
        previousPage: upcomingEventsData?.previousPage,
        pageSize: eventsData?.upcomingEventsParams?.pageSize,

        transformRow: (item) => ({
            eventName: item?.eventName,
            eventCategory: item?.eventCategory,
            startDate: item?.startDate && format(new Date(item?.startDate), 'yyyy-MM-dd'),
            endDate: item?.endDate && format(new Date(item?.endDate), 'yyyy-MM-dd'),
            venue: <Box
                wordBreak="break-word"
            >
                {item?.eventLocation}
            </Box>,
            creditPoints: item?.creditPoint,
            viewDetails: item && eventType ==="upcoming" ? (
                <Button onClick={() => handleViewEventDetails(item)} fontWeight={'bold'} fontSize={'14px'} bgColor={'#812773'} color={'white'} px={'10px'} _hover={{ bgColor: '' }} >View Details</Button>
            ): null,
        }),
    };


    return (
        <>
            <Box bgColor={'#FFFFFF'} mb={5}>
                <Flex flexDirection={'row'} justifyContent={'space-between'} alignItems={'center'} gap={'20px'} px={'20px'}>
                    <Text fontSize={'18px'} fontWeight={'700'} color={'#D11A2A'} opacity={'50%'}>Events</Text>
                </Flex>
                <Box
                    borderTop="10px solid transparent"
                    borderRadius="8px"
                    sx={{
                    borderImage: "linear-gradient(to right, #E53E3E, #812773, #E53E3E)",
                    borderImageSlice:   1 ,
                    }}
                />
                <Flex gap={5} px={3} py={7} alignItems={'center'}>
                    <Text fontWeight={500} fontSize={'16px'} color={'#000000'}>Credit Points Accumulated</Text>
                    <Text bgColor={'#005E39'} borderRadius={'5px'} color={'white'} p={1} width={'65px'} textAlign={'center'}>
                        32
                    </Text>
                </Flex>
            </Box>
            <Box bgColor={'#FFFFFF'} pt={2} pl={1}>
                <Tabs variant='unstyled'>
                    <TabList gap={'20px'} flexDirection={['column', 'row', 'row']} pb={4} justifyContent={['center', 'flex-start', 'flex-start']} alignItems={'center'}>
                        <Tab _selected={{ color: '#FFFFFF', bg: '#D11A2A' }} bg={'#E9E9E9'} w={['100%', '18%', '18%', '18%']} borderRadius={'4px'} lineHeight={'-0.25px'} color={'#54595F'}
                        onClick={() => setEventType('upcoming')}>
                            Upcoming
                        </Tab>
                        <Tab _selected={{ color: '#FFFFFF', bg: '#D11A2A' }} bg={'#E9E9E9'} w={['100%', '18%', '18%', '18%']} borderRadius={'4px'} lineHeight={'-0.25px'} color={'#54595F'}
                        onClick={() => setEventType('past')}>
                            Past
                        </Tab>
                    </TabList>
                    <TabPanels>
                        <TabPanel>
                            {eventsData?.loading ? (
                                <Flex justifyContent={'center'} alignItems={'center'}>
                                    <DotLoader />
                                </Flex>
                            ) : (
                                <CustomTablePage2 {...tableProps} />
                            )}
                        </TabPanel>
                        <TabPanel>
                            {eventsData?.loading ? (
                                <Flex justifyContent={'center'} alignItems={'center'}>
                                    <DotLoader />
                                </Flex>
                            ) : (
                                <CustomTablePage2 {...tableProps} />
                            )}
                        </TabPanel>
                    </TabPanels>
                </Tabs>
            </Box>
        </>
    );
}

export default EventMgtMemberModule;
